import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "Billing";
const json = { "Content-Type": "application/json" };

/**
 * What the club pays. Read-only by design — rates are commercial terms set in
 * the database, so there is no save method here and no endpoint behind one.
 */
export const BillingService = {
	endpoint,
	getPlan: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Plan`, {headers: json, method: "GET"}),
	getSummary: async (from?: string, to?: string) => {
		const query = from && to ? `?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}` : "";
		return await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Summary${query}`, {headers: json, method: "GET"});
	}
}
